import { render, staticRenderFns } from "./IncidentIcon.vue?vue&type=template&id=3ea51d8e&scoped=true&lang=pug"
import script from "./IncidentIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IncidentIcon.vue?vue&type=style&index=0&id=3ea51d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea51d8e",
  null
  
)

export default component.exports